const actions = {
    STOCK_TRANSFER_SET_TRANSACTION: 'STOCK_TRANSFER_SET_TRANSACTION',
    STOCK_TRANSFER_SET_EDIT_LINE: 'STOCK_TRANSFER_SET_EDIT_LINE',
    STOCK_TRANSFER_EDIT_PREV_LINE: 'STOCK_TRANSFER_EDIT_PREV_LINE',
    STOCK_TRANSFER_EDIT_NEXT_LINE: 'STOCK_TRANSFER_EDIT_NEXT_LINE',
    STOCK_TRANSFER_SET_FOCUSED_ELEMENT: 'STOCK_TRANSFER_SET_FOCUSED_ELEMENT',
    STOCK_TRANSFER_SET_ITEMS: 'STOCK_TRANSFER_SET_ITEMS',
    STOCK_TRANSFER_SET_ITEM: 'STOCK_TRANSFER_SET_ITEM',
    STOCK_TRANSFER_ADD_ITEM: 'STOCK_TRANSFER_ADD_ITEM',
    STOCK_TRANSFER_ADD_ITEMS: 'STOCK_TRANSFER_ADD_ITEMS',
    STOCK_TRANSFER_REMOVE_ITEM: 'STOCK_TRANSFER_REMOVE_ITEM',

    setTransaction: (transaction, reset = false) => ({
        type: actions.STOCK_TRANSFER_SET_TRANSACTION,
        transaction,
        reset,
    }),

    setEditLine: line => ({
        type: actions.STOCK_TRANSFER_SET_EDIT_LINE,
        line,
    }),
    editPrevLine: () => ({
        type: actions.STOCK_TRANSFER_EDIT_PREV_LINE,
    }),
    editNextLine: () => ({
        type: actions.STOCK_TRANSFER_EDIT_NEXT_LINE,
    }),
    setFocusedElement: element => ({
        type: actions.STOCK_TRANSFER_SET_FOCUSED_ELEMENT,
        element,
    }),
    setItems: items => ({
        type: actions.STOCK_TRANSFER_SET_ITEMS,
        items,
    }),
    setItem: item => ({
        type: actions.STOCK_TRANSFER_SET_ITEM,
        item,
    }),
    addItem: (item, editItem = false) => ({
        type: actions.STOCK_TRANSFER_ADD_ITEM,
        item,
        editItem,
    }),
    addItems: items => ({
        type: actions.STOCK_TRANSFER_ADD_ITEMS,
        items,
    }),
    removeItem: line => ({
        type: actions.STOCK_TRANSFER_REMOVE_ITEM,
        line,
    }),
};
export default actions;
